import Vue from "vue";

Vue.filter("clean_date", d => {
  if (d && typeof(d) !== "object") {
    d = new Date(d);
  }
  if (d) {
    return d.toISOString().split('T')[0];
  }
  return d;
})

Vue.filter("formatMoney", val => {
  // Convert the input to a number and check if it's a valid number
  const amount = parseFloat(val);
  if (isNaN(amount)) {
    return 'Invalid input';
  }

  // Format the number with commas for thousands separator and 2 decimal places
  const formattedAmount = amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  return formattedAmount;
})

Vue.filter("formatPercent", val => {
    const num = parseFloat(val);
    const percent = Math.round(num  * 100);
    // Return the formatted percentage as a string
    return percent.toString() + '%';
})

